<template>
    <content-view class="detail">
        <div class="bg-white pl32 pr32 pt32">
            <div class="form form_3 pb16">
                <div class="form-item">
                    <div class="form-item-key">出库编号：</div>
                    <div class="form-item-val">{{order_detail.serial }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">出库状态：</div>
                    <div class="form-item-val">{{ order_detail.status == 4 ? "待出库" : "已出库"}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">商户名称：</div>
                    <div class="form-item-val">{{recycling_card.username}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">商户帐号：</div>
                    <div class="form-item-val">{{ recycling_card.useraccount}}</div>
                </div>

                <div class="form-item">
                    <div class="form-item-key">车牌号码：</div>
                    <div class="form-item-val">{{ recycling_card.drive_num}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">司机姓名：</div>
                    <div class="form-item-val">{{recycling_card.drive_name }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">大类：</div>
                    <div class="form-item-val">{{category_detail.parent_category_name }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">小类：</div>
                    <div class="form-item-val">{{ category_detail.category_name}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">毛重：</div>
                    <div class="form-item-val">{{category_detail.total_weight }}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">皮重：</div>
                    <div class="form-item-val">{{ category_detail.actual_weight}}</div>
                </div>
                 <div class="form-item">
                    <div class="form-item-key">净重：</div>
                    <div class="form-item-val">{{ category_detail.net_weight}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">提交时间：</div>
                    <div class="form-item-val">{{ order_detail.created_at}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">出库时间：</div>
                    <div class="form-item-val">{{ order_detail.updated_at}}</div>
                </div>
                <div class="form-item">
                    <div class="form-item-key">二维码：</div>
                    <div class="form-item-val">
                        <div class="qrcode" id="qrcode" ref="qrCode"></div>
                    </div>
                </div>
            </div>
            <div class="form form_3 pb16 pt16">
                <div class="form-item">
                    <div class="form-item-key form-item-key-img">第一次称重图片：</div>
                    <div class="form-item-val">
                        <img 
                            class="image"
                            v-for="(item,index) in category_detail.first_image"
                            :key="index"
                            :src="item" alt=""
                        >
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-item-key form-item-key-img">第二次称重图片：</div>
                    <div class="form-item-val">
                        <img 
                            class="image"
                            v-for="(item,index) in category_detail.second_image"
                            :key="index"
                            :src="item" alt=""
                        >
                    </div>
                </div>
            </div>
            <div class="text-center mt32">
                <a-button
                    type="primary"
                    class="mr8"
                    @click="prev"
                >返 回</a-button>
            </div>
        </div>
    </content-view>
</template>
<script>
import QRCode from 'qrcodejs2';
export default {
    name: "detail",
    data() {
        return {
            orderTotal: "",
            columns: [
                {
                    title: "图片",
                    dataIndex: "icon",
                    scopedSlots: { customRender: "icon" }
                },
                {
                    title: "大件类目",
                    dataIndex: "large_class"
                },
                {
                    title: "大件型号",
                    dataIndex: "subclass"
                },
                {
                    title: "数量",
                    dataIndex: "num"
                },
                {
                    title: "参考价",
                    dataIndex: "price"
                }
            ],
            recycling_card: {},
            category_detail: {},
            pay_detail: {},
            order_detail: {},
            qrcode: "",
            serial: ""
        };
    },
    components: {},
    methods: {
        getDetail() {
            let formData = { serial: this.serial };
            formData['admin_id'] = JSON.parse(localStorage.user).id;
            formData['admin_status'] = JSON.parse(localStorage.user).status;
            this.$api.order.sellDetail(formData).then(res => {               
                // this.listInfo = res.data;
                this.recycling_card = res.data.recycling_card;
                this.category_detail = res.data.category_detail;
                this.pay_detail = res.data.pay_detail;
                this.order_detail = res.data.order_detail;
                this.qrcode = res.data.content;
                let self = this;
                this.$nextTick(() => {
                    new QRCode(self.$refs.qrCode,{
                        text: res.data.content,
                        width: 100,
                        height: 100,
                        colorDark: "#333333", //二维码颜色
                        colorLight: "#ffffff", //二维码背景色
                        correctLevel: QRCode.CorrectLevel.L//容错率，L/M/H
                    })
                }); 
            });
        },
        prev() {
            window.history.go(-1);
        }
    },
    created() {
        this.serial = this.$route.query.serial;
        this.getDetail();
    },
    mounted() {}
};
</script>
<style rel="stylesheet/scss" lang="scss">
.detail {
    .form {
        border-bottom: 1px solid $text-color-black-15;
    }
    .ant-btn-primary {
        width: 81px;
    }
    .fontWeight {
        font-weight: bold;
    }
    .tableImg {
        width: 56px;
        height: 56px;
    }
    .form-item-key {
        min-width: 70px;
    }
    .form-item-key-img {
        min-width: 120px !important;
    }
    .form-item-val {
        .image {
            padding-right: 10px;
            margin-bottom: 10px;
        }
    }
}
</style>